import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const Shopping = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Shoppings"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddShopping = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Shopping"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditShopping = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Shopping"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};
